import { fetchReferralCodes, createReferralCode, updateReferralCode, fetchAllReferralCodes } from '@/lib/db/DBReferralHelpers';
import { toast } from 'sonner';
import { TReferralCode } from '@shared/types/db/referrals-codes-base';
import { createReferral } from '@/lib/db/DBReferralCodesHelpers';
import { useReferralQuery, useUserCloudQuery } from './useReferralQuery';
import { useQueryClient } from '@tanstack/react-query';
export default function useReferralCode(PKP, setReferralUrlCode) {
  const queryClient = useQueryClient();
  const {
    data: cloudData,
    isLoading: loadingCloudData
  } = useUserCloudQuery(PKP);
  const {
    data: referralData,
    isLoading: loadingReferralData
  } = useReferralQuery(PKP, cloudData);
  const loadingQueries = loadingCloudData || loadingReferralData;
  const generateRandomCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let code = '';
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code.toUpperCase();
  };
  const handleCreateReferralForNewUser = async (cloudData: any) => {
    if (!PKP?.ethAddress || !cloudData?.data?.user_id) return;
    const newReferralCode: TReferralCode = {
      user_id: cloudData.data.user_id,
      eth_address: PKP?.ethAddress,
      referral_code: generateRandomCode(),
      // Random 6-character code
      times_used: 0,
      remaining_uses: 10,
      points: 0
    };
    const result = await createReferralCode(newReferralCode);
    if (result.data) {
      queryClient.invalidateQueries({
        queryKey: ['referrals']
      });
    } else {
      setReferralUrlCode('');
      console.log('Failed to create referral code');
      toast.error('Failed to create referral code');
    }
  };
  const handleUseReferralCode = async (inputCode: string) => {
    console.log('cloudData from use ref code', cloudData);
    if (!cloudData || !cloudData?.data || !cloudData?.data?.user_id) return;
    inputCode = inputCode.toUpperCase();
    const result: any = await fetchReferralCodes({
      referralCode: inputCode
    });
    if (result.data && result.data.remaining_uses > 0) {
      const updatedReferralCode: TReferralCode = {
        ...result.data,
        times_used: result.data.times_used + 1,
        remaining_uses: result.data.remaining_uses - 1,
        points: result.data.points + 1000
      };
      const referralCreation = await createReferral({
        referrer_user_id: result.data.user_id,
        referree_user_id: cloudData?.data?.user_id,
        referrer_eth_address: result.data.eth_address,
        referree_eth_address: PKP?.ethAddress
      });
      console.log('referralCreation', referralCreation);
      const updateResult = await updateReferralCode(updatedReferralCode);
      if (updateResult.data) {
        setReferralUrlCode('');
        await handleCreateReferralForNewUser(cloudData);
      } else {
        setReferralUrlCode('');
        console.log('Failed to update referral code');
        toast.error('Failed to update referral code');
      }
    } else {
      setReferralUrlCode('');
      console.log('Invalid or expired referral code');
      toast.error('Invalid or expired referral code');
    }
  };
  return {
    loadingQueries,
    referralData,
    handleUseReferralCode,
    handleCreateReferralForNewUser,
    cloudData
  };
}